/**
 * Returns an href that can only open an http(s) page, or undefined.
 *
 * Merchants control fields such as websiteUrl, logoUrl and webHookPostUrl, and
 * React does not block `javascript:` hrefs, so rendering those values as links
 * directly lets a merchant run script in an admin's session. A bare host
 * ("www.example.com") is treated as https.
 */
export const safeExternalUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  const trimmed = String(url).trim();
  // Browsers ignore whitespace/control characters inside a scheme ("java\tscript:").
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed.replace(/[\u0000- \u007f-\u009f]/g, ''));
  try {
    const parsed = new URL(hasScheme ? trimmed : `https://${trimmed}`);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : undefined;
  } catch {
    return undefined;
  }
};
